import { render } from "./NumberField.vue?vue&type=template&id=223e35b0&ts=true"
import script from "./NumberField.vue?vue&type=script&lang=ts"
export * from "./NumberField.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__